import React, { useState } from 'react'

export const ChevronDown = (props) => {
    return <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 1.25L5 4.75L1.5 1.25" stroke="#130F26" strokeWidth="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

}